module.exports = function () {
    $(document).ready(function () {

        var helper = require('../../helper');

        /*********************
         * TYPEAHEAD SECTION *
         *********************/
        /** Make engine object */
        var engine = new Bloodhound({
            datumTokenizer: function (datum) {
                return Bloodhound.tokenizers.whitespace(datum.name);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: helper.getOrigin() + "/api/properties/all/search/%QUERY",
                wildcard: '%QUERY'
            },
            filter: function (response) {
                return $.map(response.properties, function (object) {
                    return {
                        id: object.id,
                        name: object.name,
                        property_id: object.property_id
                    };
                });
            }
        });

        /** Run TypeAhead */
        $('.typeahead').typeahead(null, {
            minLength: 1,
            display: 'name',
            valueKey: 'id',
            name: 'suggestions',
            displayKey: 'name',
            limit: 15,
            templates: {
                empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find properties', '</strong></div>'].join('\n'),
                suggestion: function (data) {
                    return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.name + ' (' + data.property_id + ')' + '</strong></p>';
                }
            },
            source: engine
        });


        /*************************************
         * TYPEAHEAD SELECTED PROPERTY EVENT *
         *************************************/
        $('.js-property-field-typeahead').bind('typeahead:select', function (ev, suggestions) {

            var $this = $(this),
                index = $this.data('index');

            var newFieldGroup = '<div class="row">' +
                '<input name="inspections['+index+'][property_id]" type="hidden" value="'+suggestions.id+'"/><input name="inspections['+index+'][property_name]" type="hidden" value="'+suggestions.name+'"/>' +
                '<div class="col-sm-1 pull-left"><button class="btn btn-remove" type="button" style="border:none;background:transparent;color:red;font-weight: bold;">Delete</button></div>' +
                '<div class="col-sm-4"><div class="form-group"><label for="inspections['+index+'][property_name]" class="control-label col-xs-12">'+suggestions.name+'</label></div></div>' +
                '<div class="col-sm-3"><div class="form-group"><label for="inspections['+index+'][day]" class="control-label col-sm-5 label-required">Day</label><div class="col-sm-7"><input class="form-control js-datepicker" required="required" name="inspections['+index+'][day]" type="text" id="inspections['+index+'][day]"></div></div></div>' +
                '<div class="col-sm-2"><div class="form-group"><label for="inspections['+index+'][time_from]" class="control-label col-sm-5 label-required">From</label><div class="col-sm-7"><input class="form-control js-timepicker" required="required" name="inspections['+index+'][time_from]" type="text" id="inspections['+index+'][time_from]"></div></div></div>' +
                '<div class="col-sm-2"><div class="form-group"><label for="inspections['+index+'][time_to]" class="control-label col-sm-5">To</label><div class="col-sm-7"><input class="form-control js-timepicker" name="inspections['+index+'][time_to]" type="text" id="inspections['+index+'][time_to]"></div></div></div>' +
		        '<div class="col-sm-12"><div class="form-group"><label for="inspections['+index+'][description]" class="control-label col-sm-3">Description</label><div class="col-sm-9"><textarea class="form-control" name="inspections['+index+'][description]" id="inspections['+index+'][description]" rows="3"></textarea></div></div></div></div>';

            var controlForm = $('.controls');

            $(newFieldGroup).appendTo(controlForm);

            $('#new_field_input').val('');

            $this.data('index', ++index)
        });

        $(document).on('click', '.js-datepicker', function(e)
        {
       //     console.log('datepicker');
            $(this).datepicker({
                autoclose: true,
                format: "dd/mm/yyyy"
            });

        }).on('click', '.js-timepicker', function(e)
        {
       //     console.log('timepicker');
            $(this).datetimepicker({
                format: 'HH:mm'
            });
        }).on('click', '.btn-remove', function(e)
        {
      //      console.log('chcesz usunąć');
            $(this).parents('.row:first').remove();
            e.preventDefault();
            return false;
        });

    });
}();
